
import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { InsuranceDto } from './insurance-dto';



export class AllInsuranceResponse extends GlobalResponseObject {
    data?: InsuranceDto[];

    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data /RackDetails[]
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: InsuranceDto[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}

 